module.exports = [
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (130 mm), asta (600 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34195001",
		"textblock_2nd_text": "Termostatico per doccia Grohtherm 2000 con set asta doccia GROHE Euphoria (costituito da manopola doccia da 110 mm con tre tipologie di getto, asta da 600 mm, flessibile da 1750 mm e mensola)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19468000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19468000/640/19468000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Miscelatore termostatico <br />per vasca-doccia o doccia <br />con deviatore a 2 vie",
		"textblock_1st_text": "19468000",
		"textblock_2nd_text": "Pannello termostatico GROHE Grohtherm 3000 Cosmopolitan con deviatore a 2 vie (per vasche o docce con più di un\\'uscita) per termostatico da incasso GROHE Rapido T",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19468000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19567000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19567000/640/19567000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Miscelatore termostatico <br />per vasca-doccia o doccia <br />con deviatore a 2 vie",
		"textblock_1st_text": "19567000",
		"textblock_2nd_text": "Pannello termostatico GROHE Grohtherm 3000 Cosmopolitan con deviatore a 2 vie (per vasche o docce con più di un\\'uscita) per termostatico da incasso GROHE Rapido T",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19567000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Miscelatore termostatico <br />\nper doccia",
		"textblock_1st_text": "34286002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set Doccia Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 3000 Cosmopolitan Perfect con soffione in metallo da 310 mm Rainshower Cosmopolitan, manopola doccia Sena e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set Doccia Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 3000 Cosmopolitan Perfect con soffione in metallo da 310 mm Rainshower Cosmopolitan, manopola doccia Sena e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Set Doccia Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm Cube Perfect con soffione da 230 mm Rainshower Allure, manopola doccia Euphoria Cube e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Set Doccia Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 2000 Perfect con soffione in metallo da 210 mm Rainshower Cosmopolitan, manopola doccia Euphoria Cosmopolitan e miscelatore termostatico Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Miscelatore termostatico <br />\nper doccia",
		"textblock_1st_text": "34321002",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19355001",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19355001/640/19355001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Miscelatore termostatico <br />per vasca-doccia o doccia <br />con deviatore a 2 vie",
		"textblock_1st_text": "19355001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19355001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Colonna di scarico",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Colonna di scarico",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a parete sporgenza 380 mm, 1 getto",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Soffione doccia laterale",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27265000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27265000/640/27265000.jpg",
		"headline": "Euphoria 110 Mono",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27265000",
		"textblock_2nd_text": "GROHE Euphoria 110 Mono, manopola doccia, 1 getto",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27265000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Set asta doccia a getto fisso",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27661000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27661000/640/27661000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Manopola doccia a 2 getti",
		"textblock_1st_text": "27661000",
		"textblock_2nd_text": "Manopola GROHE Power&Soul Cosmopolitan, 115 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27661000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Manopola doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul® Cosmopolitan 130, manopola doccia, 4+ getti",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set asta doccia a 2 getti",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Set doccia completo a 4 tipologie di getto combinabili",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28628000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28628000/640/28628000.jpg",
		"headline": "Relexa",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "28628000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28628000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (130 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con manopola (160 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Braccio a parete<br />sporgenza 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Supporto a parete per manopola doccia Eurocube, finitura cromata e meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico GROHE Rainshower® SmartControl 360 MONO",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 310 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27911000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27911000/640/27911000.jpg",
		"headline": "Euphoria Power&Soul System 190",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27911000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27911000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27696000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27696000/640/27696000.jpg",
		"headline": "Euphoria Cube System 150",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27696000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Cube 152 con deviatore, finitura cromo, meccanica tedesca, con soffione doccia da 152 mm e manopola doccia Stick",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27696000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico GROHE Rainshower® SmartControl 360 DUO",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico e bocca per vasca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Manopola doccia",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Soffione doccia",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 400 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Cube XXL 230 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria XXL con miscelatore termostatico: finitura cromo e meccanica tedesca per un soffione doccia in metallo da 310 mm e manopola a tre getti da 110 mm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 310 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Set asta doccia a getto fisso",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con deviatore",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico e soffioni laterali",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico e getti corpo",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23058003",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23058003/640/23058003.jpg",
		"headline": "Euphoria Eurodisc Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "23058003",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/23058003",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Cube XXL con miscelatore monocomando: finitura cromo e qualità tedesca per un soffione doccia in metallo da 230 mm e manopola a tre getti.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Sistema doccia GROHE Rainshower 210 con termostatico",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Manopola doccia a 2 getti,<br /> disco getti bianco",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "Sistema doccia esterno GROHE Rainshower SmartControl 360 MONO con miscelatore termostatico. cromo, ecocompatibile e made in Germany: soffione doccia da 360 mm (disco getti bianco) e manopola da 115 mm con quattro getti.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico esterno GROHE Rainshower SmartControl 360 DUO. cromo, ecocompatibile, made in Germany, soffione doccia da 360 mm (con disco getti) con getto GROHE TrioMassage e manopola doccia da 115 mm con due getti.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Sistema doccia<br />con termostatico Grohtherm SmartControl<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "Sistema doccia con miscelatore termostatico GROHE Rainshower SmartControl 360 DUO Combi. cromo, ecocompatibile e made in Germany: Soffione doccia da 360 mm con getto GROHE TrioMassage e manopola doccia da 115 mm con due getti.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostatico a 3 vie<br /> con combinazione esterna/ad incasso",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "Miscelatore termostatico per doccia GROHE Grohtherm SmartControl Combi con tre valvole. Cromo con disco getti bianco, meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostatico esterno a 2 vie<br /> con combinazione esterna/ad incasso",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "Miscelatori termostatici GROHE Grohtherm SmartControl Combi con due valvole. Cromo con disco getti bianco, meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Corpo incasso per varianti<br />con combinazione esterna/ad incasso",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "Rapido SmartBox",
		"subheadline": "Corpo incasso universale",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Valvola di protezione antiriflusso (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27748000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Set soffione doccia a parete sporgenza 450mm, 2 getti",
		"textblock_1st_text": "26254LS0",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower 360 DUO. Colore cromo e l’affidabilità del made in Germany: Soffione da 360 mm (disco getti bianco) con getto GROHE TrioMassage e braccio da 450 mm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Manopola doccia a 4 tipologie di getto combinabili,<br />disco getti bianco",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26405000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26405000/640/26405000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Set doccia completo",
		"textblock_1st_text": "26405000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26405000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Corpo incasso per set soffione doccia 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Set soffione doccia a parete sporgenza 450mm, 2 getti",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower® 360 DUO, 2 tipologie di getto",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, set soffione con installazione a parete con braccio di 286 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27134000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27134000/640/27134000.jpg",
		"headline": "Rainshower Cosmopolitan 160",
		"subheadline": "Soffione doccia a 4 getti",
		"textblock_1st_text": "27134000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27134000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G165",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35500000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35500000/640/35500000.jpg",
		"headline": "GROHE Rapido T",
		"subheadline": "Corpo incasso per miscelatori termostatici",
		"textblock_1st_text": "35500000",
		"textblock_2nd_text": "Miscelatore termostatico universale GROHE Rapido T per installazione a incasso.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/35500000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G223",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Asta doccia 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile antitorsione \"Twistfree\" 1750 mm",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile antitorsione \"Twistfree\" 1250 mm",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Set soffione doccia a soffitto altezza 154mm, 1 getto",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower® Cosmopolitan 310, set soffione, braccio doccia a soffitto di 142 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Set soffione doccia a parete sporgenza 380 mm, 1 getto",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con manopola (130 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Set asta doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (160 mm), asta (900 mm) e flessibile (1.750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set doccia completo a 2 getti",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Set GROHE Power&Soul con soffione (115 mm), flessibile per doccia (1.250 mm) e supporto per manopola",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27765000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27765000/640/27765000.jpg",
		"headline": "Power&Soul Cosmopolitan 190",
		"subheadline": "Soffione doccia a 4 tipologie di getto combinabili",
		"textblock_1st_text": "27765000",
		"textblock_2nd_text": "Soffione GROHE Power&Soul Cosmopolitan, 190 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27765000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set asta doccia a 2 getti",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Set GROHE Power&Soul con manopola (115 mm), asta (900 mm) e flessibile (1.750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set doccia completo a 2 getti",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan con soffione (115 mm), flessibile per doccia (1.250 mm) e supporto per manopola",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Supporto a parete<br />per manopola doccia",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28679000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28679000/640/28679000.jpg",
		"headline": "Relexa",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "28679000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28679000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G091",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Supporto a parete<br />per manopola doccia",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Raccordo erogatore",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flessibile antitorsione \"Twistfree\" 1500 mm",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flessibile GROHE SilverFlex con connettore girevole per la funzione TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Set soffione doccia a parete sporgenza 286 mm, 1 getto",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Asta doccia 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bocca vasca",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a tre vie. Forma rotonda, finitura Moon White, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a tre vie. Forma quadrata, finitura Moon White, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a due vie. Forma quadrata, finitura Moon White, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per la doccia Grohtherm SmartControl a una via. Forma quadrata, finitura Moon White, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a due vie. Forma rotonda, finitura Moon White, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per la doccia Grohtherm SmartControl a una via. Forma rotonda, finitura Moon White, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a tre vie. Forma quadrata, finitura cromo, l’affidabilità del made in Germany garantita da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie<br />con supporto manopola doccia integrato",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso Grohtherm SmartControl a due vie per doccia o vasca con supporto manopola doccia integrato. Forma quadrata, finitura cromo, l’affidabilità del made in Germany garantita da GROHE.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a due vie. Forma quadrata, finitura cromo, l’affidabilità del made in Germany garantita da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per la doccia Grohtherm SmartControl a una via. Forma quadrata, finitura cromo, l’affidabilità del made in Germany garantita da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 3 vie",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a tre vie. Forma rotonda, finitura cromo, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie<br />con supporto manopola doccia integrato",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso Grohtherm SmartControl a due vie per doccia o vasca con supporto manopola doccia integrato. Forma rotonda, finitura cromo, affidabilità del made in Germany garantito da GROHE.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 2 vie",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per doccia o vasca Grohtherm SmartControl a due vie. Forma rotonda, finitura cromo, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Miscelatore termostatico a 1 via",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Miscelatore termostatico da incasso per la doccia Grohtherm SmartControl a una via. Forma rotonda, finitura cromo, affidabilità del made in Germany garantito da GROHE. Funzioni di tutela dell\\'ambiente e di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Set doccia Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "Set doccia GROHE Grohtherm 1000 Perfect con soffione da 210 mm e manopola doccia a due getti da 100 mm con finitura cromo.  Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "Sistema doccia GROHE Tempesta Cosmopolitan 210 con miscelatore termostatico, soffione da 210 mm e manopola doccia a due getti da 100 mm con finitura cromo. Facile da montare e pulire. Meccanica tedesca.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria 260 con miscelatore termostatico, soffione a tre getti da 260 mm e manopola doccia a tre getti da 110 mm con finitura cromo a risparmio idrico. Facile da montare e pulire. Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "Sistema vasca/doccia GROHE Euphoria 260 con miscelatore termostatico per vasche da bagno, soffione a tre getti da 260 mm e manopola doccia a tre getti da 110 mm con finitura cromo a risparmio idrico. Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria 260 con miscelatore monocomando, soffione a tre getti SmartControl da 260 mm e manopola doccia a tre getti da 110 mm con finitura cromo a risparmio idrico. Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set soffione doccia a soffitto altezza 142mm, 3 getti",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "Set soffione doccia con tre zone getti GROHE Euphoria 260 SmartControl. Soffione doccia da 260 mm e braccio a soffitto GROHE Rainshower (142 mm) con finitura cromo. Facile da montare e pulire. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Set soffione doccia a parete sporgenza 380mm, 3 getti",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "Set soffione doccia con tre zone getti GROHE Euphoria 260 SmartControl. Soffione doccia da 260 mm e braccio GROHE Rainshower (380 mm) con finitura cromo. Facile da montare e pulire. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set soffione doccia a parete sporgenza 422mm, 1 getto",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Set soffione doccia a parete sporgenza 422mm, 1 getto",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 1 getto",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con deviatore",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria 260 con deviatore. Soffione doccia a tre getti da 260 mm e manopola doccia a tre getti da 110 mm con finitura cromo e risparmio idrico. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria 260 con miscelatore termostatico, soffione a tre getti da 260 mm e manopola doccia a tre getti da 110 mm con finitura cromo. Facile da montare e pulire. Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "Sistema doccia GROHE Tempesta Cosmopolitan 210 con miscelatore monocomando per vasche da bagno, soffione da 210 mm e manopola doccia a due getti da 100 mm con finitura cromo. Facile da montare e pulire. Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema doccia<br />con miscelatore termostatico",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "Sistema doccia GROHE Tempesta Cosmopolitan 210 con miscelatore termostatico per vasche da bagno, soffione da 210 mm e manopola doccia a due getti da 100 mm con finitura cromo. Facile da montare e pulire. Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23061002",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23061002/640/23061002.jpg",
		"headline": "Euphoria Concetto System 260",
		"subheadline": "Sistema doccia<br />con miscelatore monocomando",
		"textblock_1st_text": "23061002",
		"textblock_2nd_text": "Sistema doccia GROHE Euphoria Concetto 260 con miscelatore monocomando, soffione a tre getti SmartControl da 260 mm e manopola doccia a bastoncino con finitura cromo. Meccanica tedesca",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/23061002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Set soffione doccia a parete sporgenza 430mm, 2 getti",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower 310 SmartActive con 2 opzioni di getto. Soffione a parete da 310 mm con braccio di 400 mm, finitura cromo e disco getti bianco, forma rotonda. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 2 getti",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower 310 SmartActive con 2 opzioni di getto. Soffione a soffitto da 310 mm con braccio di 142 mm, finitura cromo, forma rotonda. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 2 getti",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower 310 SmartActive con 2 opzioni di getto. Soffione a soffitto da 310 mm con braccio di 142 mm, finitura cromo e disco getti bianco, forma rotonda. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Set soffione doccia a parete sporgenza 430mm, 2 getti",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower 310 SmartActive CUBE con 2 opzioni di getto. Soffione a parete da 310 mm con braccio di 400 mm, finitura cromo e disco getti bianco, forma quadrata. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 2 getti",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower 310 SmartActive CUBE con 2 opzioni di getto. Soffione a soffitto da 310 mm con braccio di 142 mm, finitura cromo, forma quadrata. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Set soffione doccia a soffitto altezza 142 mm, 2 getti",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "Set soffione doccia GROHE Rainshower 310 SmartActive CUBE con 2 opzioni di getto. Soffione a soffitto da 310 mm con braccio di 142 mm, finitura color cromo e disco getti bianco, forma quadrata. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Corpo incasso universale",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set doccia Rainshower SmartActive 310",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Set doccia Grohtherm SmartControl Perfect con miscelatore termostatico a tre vie da incasso con soffione, braccio, manopola doccia e flessibile. Forma rotonda. Finitura cromo, made in Germany.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set doccia Rainshower SmartActive 310 Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Set doccia Grohtherm SmartControl Perfect con miscelatore termostatico a tre vie da incasso con soffione, braccio, manopola doccia e flessibile. Forma quadrata. Finitura cromo, made in Germany.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Sistema doccia FLEX<br />con deviatore",
		"textblock_1st_text": "26381001",
		"textblock_2nd_text": "Sistema doccia GROHE New Tempesta 210 FLEX con deviatore; compatibile con tutte le valvole esistenti per rinnovare il bagno con facilità. Made in Germany con soffione doccia da 210 mm con due getti e manopola doccia da 100 mm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34566001",
		"textblock_2nd_text": "Termostatico per doccia Grohtherm 800 con set asta doccia GROHE New Tempesta (costituito da manopola doccia da 100 mm con due tipologie di getto, asta da 900 mm e flessibile da 1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34565001",
		"textblock_2nd_text": "Termostatico per doccia Grohtherm 800 con set asta doccia GROHE New Tempesta (costituito da manopola doccia da 100 mm con due tipologie di getto, asta da 600 mm e flessibile da 1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000 New",
		"subheadline": "Miscelatore termostatico <br />per doccia",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.ch/it_ch/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.ch/it_ch/trova-grohe/trova-showroom-o-installatore.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_it_ch.json
// module id = 833
// module chunks = 0